import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, vShow as _vShow, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = { class: "header" }
const _hoisted_2 = /*#__PURE__*/_createTextVNode("선물하기")
const _hoisted_3 = { class: "gift_box_area" }
const _hoisted_4 = { class: "amount_area" }
const _hoisted_5 = { class: "prod_info_bx" }
const _hoisted_6 = { class: "prod_value" }
const _hoisted_7 = /*#__PURE__*/_createTextVNode("총 ")
const _hoisted_8 = { class: "value_txt" }
const _hoisted_9 = /*#__PURE__*/_createTextVNode("개")
const _hoisted_10 = { class: "gift_lst" }
const _hoisted_11 = { class: "sender" }
const _hoisted_12 = { class: "list_giftinfo" }
const _hoisted_13 = /*#__PURE__*/_createVNode("dt", { class: "blind" }, "기간", -1)
const _hoisted_14 = { class: "expiration_date" }
const _hoisted_15 = /*#__PURE__*/_createTextVNode("보유 선물이 없습니다.")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_header_component = _resolveComponent("header-component")
  const _component_navigator = _resolveComponent("navigator")
  const _component_sub_navigator = _resolveComponent("sub-navigator")
  const _component_sort_option_component = _resolveComponent("sort-option-component")
  const _component_ticket_list_item = _resolveComponent("ticket-list-item")
  const _component_no_ticket_component = _resolveComponent("no-ticket-component")
  const _component_toTop = _resolveComponent("toTop")

  return (_openBlock(), _createBlock("div", {
    id: "wrap",
    class: ["wrap", {app_view: _ctx.isApp}]
  }, [
    _createVNode("div", _hoisted_1, [
      _createVNode(_component_header_component, null, {
        default: _withCtx(() => [
          _hoisted_2
        ]),
        _: 1
      })
    ]),
    _createVNode("div", {
      id: "content",
      class: ["content bg_gray", {'is_complete': _ctx.isEmpty}]
    }, [
      _createVNode("div", {
        class: ["tab_menu", {'fixed': _ctx.isEmpty}]
      }, [
        _createVNode(_component_navigator, { "navigator-code": "my" }),
        _createVNode(_component_sub_navigator, { "navigator-code": "usableTicket" })
      ], 2),
      _withDirectives(_createVNode("div", _hoisted_3, [
        _createVNode("div", _hoisted_4, [
          _createVNode("div", _hoisted_5, [
            _createVNode("div", _hoisted_6, [
              _hoisted_7,
              _createVNode("em", _hoisted_8, _toDisplayString(_ctx.totalCount), 1),
              _hoisted_9
            ]),
            _createVNode(_component_sort_option_component, { onLoadNewItem: _ctx.loadNewTicket }, null, 8, ["onLoadNewItem"])
          ]),
          _createVNode("ul", _hoisted_10, [
            (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.tickets, (ticket) => {
              return (_openBlock(), _createBlock(_component_ticket_list_item, {
                key: ticket.ticketId,
                item: ticket,
                onMoveToDetailPage: ($event: any) => (_ctx.moveToDetailPage(ticket.ticketId))
              }, {
                senderOrRecipent: _withCtx(() => [
                  _createVNode("p", _hoisted_11, "from. " + _toDisplayString(ticket.senderName), 1)
                ]),
                validity: _withCtx(() => [
                  _createVNode("dl", _hoisted_12, [
                    _hoisted_13,
                    _createVNode("dd", _hoisted_14, _toDisplayString(ticket.validityEndYmd) + " 까지", 1),
                    _createVNode("dd", {
                      class: ["remaining_date", {'last_date': ticket.isValidUntilToday}]
                    }, _toDisplayString(ticket.remainedDayString), 3)
                  ])
                ]),
                _: 2
              }, 1032, ["item", "onMoveToDetailPage"]))
            }), 128))
          ])
        ])
      ], 512), [
        [_vShow, !_ctx.isFirstLoading && !_ctx.isEmpty]
      ]),
      _createVNode(_component_no_ticket_component, {
        isEmpty: !_ctx.isFirstLoading && _ctx.isEmpty,
        showGiftImage: true
      }, {
        default: _withCtx(() => [
          _hoisted_15
        ]),
        _: 1
      }, 8, ["isEmpty"])
    ], 2),
    _createVNode(_component_toTop)
  ], 2))
}